import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

export const DashboardTabs = ({ tabs, activeKey, onChange }) => {
    const btnRefs = useRef({});
    const [indicator, setIndicator] = useState({ left: 0, width: 0 });

    const measure = () => {
        const btn = btnRefs.current[activeKey];
        if (btn) setIndicator({ left: btn.offsetLeft, width: btn.offsetWidth });
    };

    useLayoutEffect(() => {
        measure();
    }, [activeKey, tabs]);

    useEffect(() => {
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [activeKey, tabs]);

    return (
        <div className="dashboard-tabs">
            <div className="dashboard-tabs__row">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        ref={(el) => (btnRefs.current[tab.key] = el)}
                        type="button"
                        className={`dashboard-tabs__btn ${activeKey === tab.key ? 'is-active' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onChange(tab.key);
                        }}
                    >
                        {tab.label}
                        {tab.count > 0 && (
                            <span className="dashboard-tabs__count" style={{ background: tab.countBg, color: tab.countColor }}>
                                {tab.count}
                            </span>
                        )}
                    </button>
                ))}
            </div>

            <span className="dashboard-tabs__track" />
            <span className="dashboard-tabs__indicator" style={{ left: indicator.left, width: indicator.width }} />
        </div>
    );
};
